"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLocationDto = instanceOfLocationDto;
exports.LocationDtoFromJSON = LocationDtoFromJSON;
exports.LocationDtoFromJSONTyped = LocationDtoFromJSONTyped;
exports.LocationDtoToJSON = LocationDtoToJSON;
exports.LocationDtoToJSONTyped = LocationDtoToJSONTyped;
/**
 * Check if a given object implements the LocationDto interface.
 */
function instanceOfLocationDto(value) {
    if (!('lat' in value) || value['lat'] === undefined)
        return false;
    if (!('lng' in value) || value['lng'] === undefined)
        return false;
    return true;
}
function LocationDtoFromJSON(json) {
    return LocationDtoFromJSONTyped(json, false);
}
function LocationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lat': json['lat'],
        'lng': json['lng'],
        'addressId': json['addressId'] == null ? undefined : json['addressId'],
    };
}
function LocationDtoToJSON(json) {
    return LocationDtoToJSONTyped(json, false);
}
function LocationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'lat': value['lat'],
        'lng': value['lng'],
        'addressId': value['addressId'],
    };
}
//# sourceMappingURL=LocationDto.js.map